import React, { useEffect, useState } from "react";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { formatDate, handleDate } from "../../../utils/commonFunctions";
import { CalenderIcon } from "../../Icon";
import {
  DropDown,
  ErrorSuccessModal,
  Loader,
  RollingLoader,
  ToggleSwitch,
} from "../../commons";
import { useLocation, useParams } from "react-router-dom";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  addBatchManagementAction,
  checkUniqueBatchNumberAction,
  getAllStockItemListAction,
  resetBatchNumberUniqueMessage,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  updateBatchManagementAction,
} from "../../../redux/clientSettings";
import {
  AddBatchPayloadType,
  CheckUniqueBatchNumberPayloadType,
  GetAllStockItemListPayloadType,
  UpdateBatchPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import { connect } from "react-redux";
import { resetMessage } from "../../../redux/jobs";
import { resetMasterStatusCode } from "../../../redux/masterData";
import useDebounce from "../../../customHooks/useDebounce";
import { SingleBatchDetailsDataType } from "../../../redux/clientSettings/clientSettingTypes";

type CheckUniqueErrorType = {
  uniqueNumberError: string;
  isUniqueError: boolean;
};

type AppProps = {
  client_code: number;
  company_name: string;
  history: any;
  token: string | null;
  allStockItemList: any[];
  dispatchResetSession: () => void;
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) => void;
  dispatchAddBatchManagement: (data: AddBatchPayloadType) => void;
  dispatchUpdateBatchManagement: (data: UpdateBatchPayloadType) => void;
  success: number | null;
  fetching: boolean;
  error: string | null;
  statusCode: number | null;
  message: string | null;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  singlebatchDetailsData?: SingleBatchDetailsDataType;
  batchNumberUniqueMessage: string | null;
  batchNumberFetching: boolean;
  dispatchCheckUniqueBatchNumberAction: (
    data: CheckUniqueBatchNumberPayloadType
  ) => void;
  dispatchResetBatchNumberUniqueMessage: () => void;
};
const AddEditBatchForm = ({
  client_code,
  company_name,
  history,
  token,
  allStockItemList,
  dispatchResetSession,
  dispatchGetAllStockItem,
  dispatchAddBatchManagement,
  dispatchUpdateBatchManagement,
  success,
  fetching,
  error,
  statusCode,
  message,
  dispatchResetClientSettingMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingsError,
  singlebatchDetailsData,
  batchNumberUniqueMessage,
  batchNumberFetching,
  dispatchCheckUniqueBatchNumberAction,
  dispatchResetBatchNumberUniqueMessage,
}: AppProps) => {
  const { pathname } = useLocation();
  const { id } = useParams<any>();
  const [checkUniqueError, setCheckUniqueError] =
    useState<CheckUniqueErrorType>({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  const { uniqueNumberError } = checkUniqueError;

  const [batchData, setBatchData] = useState<any>({
    batchNumber: "",
    manufacturingDate: "",
    expiryDate: "",
    status: true,
  });

  const [batchUniqueApiMessage, setBatchUniqueApiMessage] =
    useState<string>("");

  const [stockItemName, setStockItemName] = useState<any>({
    value: "",
    label: "Select Stock Name..",
  });
  const [uniqueCheck, setUniqueCheck] =
    useState<CheckUniqueBatchNumberPayloadType>({
      client_code: null,
      token,
      batch_number: undefined,
    });

  useEffect(() => {
    dispatchResetBatchNumberUniqueMessage();
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
  }, []);


  useEffect(() => {
    const { uniqueNumberError } = checkUniqueError;
    setBatchUniqueApiMessage("");
    if (uniqueNumberError) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        uniqueNumberError: "",
      }));
    }
    if (
      singlebatchDetailsData &&
      Object.keys(singlebatchDetailsData)?.length > 0
    ) {
      setBatchData({
        batchNumber: singlebatchDetailsData.batch_number,
        manufacturingDate: singlebatchDetailsData.manufacturing_date,
        expiryDate: singlebatchDetailsData.expiry_date,
        status: singlebatchDetailsData.is_enable === 1 ? true : false,
      });
      setStockItemName({
        value: singlebatchDetailsData.stock_item_id,
        label: singlebatchDetailsData.stock_item_name,
      });
    } else {
      setBatchData({
        batchNumber: "",
        manufacturingDate: "",
        expiryDate: "",
        status: true,
      });
    }
  }, [singlebatchDetailsData]);

  useEffect(() => {
    if (batchNumberUniqueMessage?.length) {
      setBatchUniqueApiMessage(batchNumberUniqueMessage);
    }

    if (
      batchNumberUniqueMessage?.length &&
      batchNumberUniqueMessage?.includes("not")
    ) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: true,
      }));
    } else if (
      batchNumberUniqueMessage?.length &&
      !batchNumberUniqueMessage?.includes("not")
    ) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: false,
      }));
    }
  }, [batchNumberUniqueMessage]);

  useEffect(() => {
    if (client_code && token) {
      let finalData = {
        token,
        client_code,
      };

      dispatchGetAllStockItem(finalData);
    }
  }, []);
  const option: any = allStockItemList?.map((data: any) => {
    return {
      value: data.stock_item_id,
      label: data.stock_item_name,
    };
  });

  useDebounce(
    () => {
      if (
        uniqueCheck.client_code &&
        uniqueCheck.batch_number &&
        uniqueCheck.token
      ) {
        dispatchCheckUniqueBatchNumberAction(uniqueCheck);
      }
    },
    500,
    [uniqueCheck]
  );

  const handleBatchNumberChange = (e: any) => {
    handleResetData();
    const { uniqueNumberError } = checkUniqueError;
    let targetName = e.target.name;
    if (targetName === "batchNumber" && e.target.value.length) {
      let finalData = {
        token,
        client_code,
        batch_number: e.target.value,
      };
      if (!id) {
        setUniqueCheck(finalData);
      } else if (
        id &&
        targetName === "batchNumber" &&
        e.target.value != singlebatchDetailsData?.batch_number
      ) {
        setUniqueCheck(finalData);
        handleResetData();
      } else {
        handleResetData();
        setUniqueCheck({
          client_code: null,
          token,
          batch_number: undefined,
        });
      }
    }

    if (targetName === "batchNumber") {
      setBatchData({
        ...batchData,
        batchNumber: e.target.value,
      });
    }

    if (targetName === "uniqueNumber" && uniqueNumberError) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        uniqueNumberError: "",
      }));
    }
  };

  const handleSetStockItemName = (mode: any) => {
    setStockItemName({
      value: mode?.value,
      label: mode?.label,
    });
  };
  const handleToogleStatusChange = () => {
    setBatchData({
      ...batchData,
      status: !batchData.status,
    });
  };
  const handleManufacturingDateChange = (date: any) => {
    const value = handleDate(date);
    setBatchData({
      ...batchData,
      manufacturingDate: value,
    });
  };
  const handleExpiryDateChange = (date: any) => {
    const value = handleDate(date);
    setBatchData({
      ...batchData,
      expiryDate: value,
    });
  };
  const handleResetData = () => {
    setBatchUniqueApiMessage("");

    setCheckUniqueError({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  };
  const filterPassedManufacturingDay = (date: Date) => {
    const today = new Date();
    return date <= today;
  };

  const filterFutureExpiryDay = (date: Date) => {

    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    const comparisonDate = new Date(date);
    comparisonDate.setHours(0, 0, 0, 0); 
    return comparisonDate >= today;
  };

  const handleSubmit = () => {
    let finalData = {
      token,
      clientCode: client_code,
      batchNumber: batchData?.batchNumber,
      expiryDate: batchData?.expiryDate
      ? formatDate(batchData?.expiryDate)
      : "",
      manufacturingDate:batchData?.manufacturingDate
      ? formatDate(batchData?.manufacturingDate)
      : "",
      status: batchData?.status ? 1 : 0,
      stockItem: stockItemName?.value,
    };
    if (pathname?.includes("add")) {
      dispatchAddBatchManagement(finalData);
    }
    if (pathname?.includes("edit")) {
      let finalEditData = {
        token,
        clientCode: client_code,
        batchId: id,
        batchNumber: batchData?.batchNumber,
        expiryDate: batchData?.expiryDate
          ? formatDate(batchData?.expiryDate)
          : "",
        manufacturingDate: batchData?.manufacturingDate
          ? formatDate(batchData?.manufacturingDate)
          : "",
        status: batchData?.status ? 1 : 0,
        stockItem: stockItemName?.value,
      };
      dispatchUpdateBatchManagement(finalEditData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
    if (
      (success === 1 && message === "Batch added successfully") ||
      message === "Batch updated successfully"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={message}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientSettingsSuccess();
            dispatchResetClientSettingsError();
            history?.push({
              pathname: `/client-settings/batch-management/${client_code}`,
              state: { client_code, company_name },
            });
          }}
        />
      );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Batch ID <span className="color-red">*</span></label>
            <div>
            <div className="d-flex flex-row position-relative">
              <input
                name="batchNumber"
                type="text"
                className={`form-control ${
                  !!uniqueNumberError ? "error-border" : null
                }`}
                value={batchData?.batchNumber}
                onChange={handleBatchNumberChange}
                onWheel={(event) => event.currentTarget.blur()}
              />
              {batchNumberFetching && <RollingLoader />}
            </div>
            {!!uniqueNumberError && (
                <small className="text-danger">{uniqueNumberError}</small>
              )}
            {batchNumberUniqueMessage?.includes("not") &&
                !!batchData?.batchNumber?.trim()?.length && (
                  <small className="text-danger">
                    Batch number is already in use!
                  </small>
            )}

              
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 form-group mt-3">
          <label>Manufacturing Date <span className="color-red">*</span></label>
          <div className="d-flex flex-row position-relative mt-1">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="m-0 p-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    batchData?.manufacturingDate
                      ? new Date(
                          moment(
                            `${batchData?.manufacturingDate}T00:00:00`,
                            "YYYY-MM-DD"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) =>
                    handleManufacturingDateChange(
                      e ? moment(e).format("YYYY-MM-DD") : null
                    )
                  }
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="startDate"
                  placeholderText="Choose Date"
                  className="form-control pointer"
                  filterDate={filterPassedManufacturingDay}
                />
                <span
                  className="calender-icon"
                  style={{ right: "25px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 form-group mt-3"
          style={{ marginLeft: "11px" }}
        >
          <label>Expiry Date <span className="color-red">*</span></label>
          <div className="d-flex flex-row position-relative mt-1">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="m-0 p-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    batchData?.expiryDate
                      ? new Date(
                          moment(
                            `${batchData?.expiryDate}T00:00:00`,
                            "YYYY-MM-DD"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) =>
                    handleExpiryDateChange(
                      e ? moment(e).format("YYYY-MM-DD") : null
                    )
                  }
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="endDate"
                  placeholderText="Choose Date"
                  className="form-control pointer"
                  filterDate={filterFutureExpiryDay}
                />
                <span
                  className="calender-icon"
                  style={{ right: "25px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 form-group mt-3">
          <label>Stock Name <span className="color-red">*</span></label>
          <div>
            <DropDown
              extraClasses="zindex-2"
              options={option}
              value={stockItemName}
              handleChange={handleSetStockItemName}
            />
          </div>
        </div>
        <div className="col-md-4 form-group mt-3 ml-4">
          <label htmlFor="Job Status" className="mb-2">
            Status
          </label>
          <ToggleSwitch
            handleToggleChange={() => handleToogleStatusChange()}
            isChecked={batchData?.status}
          />
        </div>
      </div>

      <div style={{ marginTop: "2rem" }}>
        <hr></hr>
      </div>

      <div className="row mt-3">
        <div className="col-md-12 d-flex justify-content-end ">
          <button
            className="btn ml-3"
            style={{ border: "1px solid #bfcbe1" }}
            onClick={() => {
              history.goBack();
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary ml-3 pr-4 pl-4"
            onClick={handleSubmit}
              disabled={
                !batchData?.batchNumber ||
                !batchData?.expiryDate ||
                !batchData?.manufacturingDate ||
                !stockItemName?.value ||
                !!uniqueNumberError || (batchNumberUniqueMessage?.includes("not") && singlebatchDetailsData?.batch_number.toString() !== batchData?.batchNumber
              )
              }
          >
            {pathname?.includes("add") ? "Save" : "Save Changes"}
          </button>
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  message: state.clientSettings.message,
  allStockItemList: state.clientSettings.allStockItemList,
  batchNumberUniqueMessage: state.clientSettings.batchNumberUniqueMessage,
  batchNumberFetching: state.clientSettings.batchNumberFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) =>
    dispatch(getAllStockItemListAction(data)),
  dispatchAddBatchManagement: (data: AddBatchPayloadType) =>
    dispatch(addBatchManagementAction(data)),
  dispatchUpdateBatchManagement: (data: UpdateBatchPayloadType) =>
    dispatch(updateBatchManagementAction(data)),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchCheckUniqueBatchNumberAction: (
    data: CheckUniqueBatchNumberPayloadType
  ) => dispatch(checkUniqueBatchNumberAction(data)),
  dispatchResetBatchNumberUniqueMessage: () =>
    dispatch(resetBatchNumberUniqueMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEditBatchForm);
